module.exports = __webpack_public_path__ + "static/img/fish25.08844be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish25.png
// module id = bxV5
// module chunks = 0